import $ from 'jquery'
import HTTP from '@/components/general/http/http'

import config from '@/config/env'

export default {
	createZip(data) {

		let url = config.api.baseUrl + '/api/v1/files-zips'

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	},
	getZips(query) {

		let url = config.api.baseUrl + '/api/v1/files-zips'

		if (query) {

			let esc = encodeURIComponent;
			let _query = Object.keys(query)
				.map(k => esc(k) + '=' + esc(query[k]))
				.join('&');

			url += '/?' + _query

		}

		return HTTP
			.request()
			.get(url)
			.then(response => response)
			.catch(error => error)

	},
	deleteZip(id) {

		let url = `${config.api.baseUrl}/api/v1/files-zips/${id}`

		return HTTP
			.request()
			.delete(url)
			.then(response => response)
			.catch(error => error)

	},
}






// WEBPACK FOOTER //
// ./src/api/contractsZips.js